"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var minigolfMonofont_sidecar_1 = require("@dive/fonts/minigolfMonofont-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var spritesUiTop_1 = require("../recyclers/spritesUiTop");
var minigolfGameState_sidecar_1 = require("../simulation/minigolfGameState-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
function render() {
    var x = 0.25;
    var xs = x;
    var y = 0.65;
    var statsIndent = 5;
    var playerStats = minigolfGameState_sidecar_1.minigolfGameState.get().playerState;
    var adv = function () {
        y++;
    };
    var wr = function (str, advance) {
        if (advance === void 0) { advance = true; }
        minigolfMonofont_sidecar_1.minigolfMonofont.writeWrapped(x, y, 200, str);
        if (advance) {
            //y++
            adv();
        }
    };
    var sym = function (num, sprite, turns, scale) {
        if (turns === void 0) { turns = 0; }
        if (scale === void 0) { scale = 1; }
        for (var i = 0; i < num; i++) {
            var adjX = x * 32;
            var adjY = y * 32;
            var sp = spritesUiTop_1.spritesUiTop.getNext(adjX + i * 20, adjY, sprite);
            sp.scale *= scale;
            sp.rotation = mathUtils_sidecar_1.mathUtils.turn(turns);
        }
    };
    var symHealth = function (num) {
        for (var i = 0; i < num; i += 2) {
            var adjX = x * 32;
            var adjY = y * 32;
            var frame = sprites_sidecar_1.sprites.minigolfHeart[0];
            if (i + 2 > num) {
                frame = sprites_sidecar_1.sprites.minigolfHeartHalf[0];
            }
            var sp = spritesUiTop_1.spritesUiTop.getNext(adjX + i * 15, adjY, frame);
            // sp.rotation = mathUtils.turn(turns)
        }
    };
    wr('Rogue Strokes: Minigolf Roguelike Dungeoncrawl 7DRL 2024 by Stevie Bee (v1.07c)');
    adv();
    if (!playerStats.didLose) {
        wr('' +
            playerStats.gameStateString +
            // calculateTicks(sp, '[orange|Exhausted]', '[red|Deceased]', spScale) +
            '');
    }
    adv();
    if (playerStats.dungeonLevel === 0) {
        adv();
        wr('Left-click to fling the ball.');
        adv();
        wr('Right-click to move the camera.');
        adv();
        wr('-R- Reset Game  -N- Regen level if stuck ');
        adv();
        wr('-F11- Play Fullscreen (recommended)');
        adv();
        wr('Reach hole 18... ');
        wr('  ...and ascend with the Amulet of Yendor to win!');
    }
    if (playerStats.didWin) {
        adv();
        wr('You ascended with the Amulet of Yendor! Congratulations!');
    }
    if (playerStats.didLose) {
        adv();
        wr('You have perished in the dungeon. Better luck next time!', false);
        adv();
        adv();
        wr('Reason: ' + playerStats.deathReason + '');
        adv();
    }
    if (playerStats.didLose || playerStats.didWin) {
        adv();
        wr('Press "R" to restart the game.');
        adv();
    }
    var h = voyageCamera_sidecar_1.voyageCamera.getGameBounds().height;
    var yh = h / 32;
    y = yh - 10 - 0.5;
    // x -= 2
    // spritesUiTop.getNext(50 + 20, 50, sprites.minigolfKey[0])
    adv();
    // if (playerStats.hasAmulet) {
    //   wr('You have the Amulet of Yendor!', false)
    //   spritesUiTop.getNext(50, 50, sprites.minigolfAmulet[0])
    // }
    // adv()
    if (playerStats.isDungeonBroken) {
        wr('This level is shattered', false);
    }
    adv();
    if (playerStats.isDungeonLocked) {
        wr('This level is locked', false);
    }
    adv();
    var puck = minigolfGameState_sidecar_1.minigolfGameState.get().currentPuck;
    if (puck && !puck.isDead) {
        var status_1 = '';
        for (var iEffect = 0; iEffect < puck.state.effects.length; iEffect++) {
            status_1 += ' -' + puck.state.effects[iEffect].type + '- ';
        }
        wr(status_1, false);
    }
    adv();
    // let health: string | number = playerStats.health
    // if (health < 0) {
    //   health =
    // }
    // Debug
    // playerStats.keys = 5
    // playerStats.hasAmulet = true
    // x += 2
    // wr('You have a key! x' + playerStats.keys, false)
    x += 0.5;
    if (playerStats.keys > 0) {
        sym(playerStats.keys, sprites_sidecar_1.sprites.minigolfKey[0], 1 / 6);
        x += playerStats.keys + 1;
    }
    if (playerStats.hasAmulet) {
        sym(1, sprites_sidecar_1.sprites.minigolfAmulet[0], 0);
    }
    x = xs;
    adv();
    wr('Hp:' +
        // calculateTicks(hp, '[orange|Critical]', '[red|Deceased]', healthScale) +
        '', false); // hp + '/' + maxHp)
    x += statsIndent;
    // wr('' + playerStats.health)
    symHealth(playerStats.health);
    if (playerStats.health < 0) {
        wr('' + 'X.X', false);
    }
    adv();
    x -= statsIndent;
    wr('Food:' +
        // calculateTicks(sp, '[orange|Exhausted]', '[red|Deceased]', spScale) +
        '', false);
    x += statsIndent;
    // wr('' + playerStats.food)
    sym(playerStats.food, sprites_sidecar_1.sprites.minigolfMeat[0], -1 / 6);
    adv();
    x -= statsIndent;
    wr('Attack:' +
        // calculateTicks(sp, '[orange|Exhausted]', '[red|Deceased]', spScale) +
        '', false);
    x += statsIndent;
    // wr('' + playerStats.attackPower)
    sym(playerStats.attackPower, sprites_sidecar_1.sprites.minigolfSword[0]);
    adv();
    x -= statsIndent;
    x += 0.2;
    // playerStats.money = 12
    sym(playerStats.money, sprites_sidecar_1.sprites.minigolfMoney[0], 0, 0.5);
    x = xs;
    adv();
    // if (playerStats.difficulty) {
    //   wr('' + playerStats.difficulty)
    // }
    wr('' + (playerStats.killedList ? playerStats.killedList : 'pacifist'));
    wr('Level ' +
        playerStats.dungeonLevel +
        // calculateTicks(sp, '[orange|Exhausted]', '[red|Deceased]', spScale) +
        '/18' +
        ' par ' +
        playerStats.levelPar +
        '   ' +
        playerStats.difficulty +
        '  ');
}
exports.render = render;
